import PropTypes from 'prop-types';
import React from 'react';
import FootballMatchEventIcon from 'modules/Football/components/svg/FootballMatchEventIcon';


export default function SubIcon(props) {
  return (
    <span className="subIcon">
      <FootballMatchEventIcon type={props.type}/>
      <span className="subTime">{props.time}</span>
    </span>
  );
}

SubIcon.propTypes = {
  type: PropTypes.string.isRequired,
  time: PropTypes.node.isRequired
}



// WEBPACK FOOTER //
// ./modules/Football/components/SubIcon.js